/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Related_TitleInputs */

const en_road_dude_related_title = /** @type {(inputs: Road_Dude_Related_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From the pickup to the Hotel Lobby.`)
};

const zh_road_dude_related_title = /** @type {(inputs: Road_Dude_Related_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从皮卡驾驶位到 Hotel Lobby。`)
};

/**
* | output |
* | --- |
* | "From the pickup to the Hotel Lobby." |
*
* @param {Road_Dude_Related_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_related_title = /** @type {((inputs?: Road_Dude_Related_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Related_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_related_title(inputs)
	return zh_road_dude_related_title(inputs)
});
export { road_dude_related_title as "road_dude.related.title" }